import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowSplitDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-split-down, branch"} maskId="square-filled-radius-0-stroke-1-IconArrowSplitDown"><path d="M6.70703 18L4.5 20.207L3.79297 19.5L6 17.293L6.70703 18Z" fill="currentColor"/><path d="M12.5 11.793L19 18.293V13H20V20H13V19H18.293L11.5 12.207V3H12.5V11.793Z" fill="currentColor"/><path d="M10.457 14.2559L8.25 16.4629L7.54297 15.7559L9.75 13.5488L10.457 14.2559Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowSplitDown;
